import React, { Component } from "react";
import { t } from "../../../components/CustomComponent.js";
import HomePropertyCard from "./HomePropertyCard.js";
import ICON from "../icons.js";

/* ============================================================================
 * HomeFeatured — "ทรัพย์แนะนำ" : แถวการ์ดทรัพย์ 4 ใบ + ลิงก์ดูทั้งหมด
 *
 * เป็นส่วนแรกที่ผู้ใช้เห็นถัดจากแบนเนอร์ จึงเหลือแค่การ์ดล้วน ๆ ไม่มีชิปกรอง
 * และตัวเรียงลำดับ (อยู่ในหน้ารายการทรัพย์เต็มที่กด "ดูทั้งหมด") เพื่อให้
 * สายตาไหลจากกล่องค้นหา -> หมวดหมู่ -> ทรัพย์ โดยไม่มีแถบเครื่องมือมาคั่น
 * ========================================================================== */
const SHOW = 4;

export default class HomeFeatured extends Component {
  render() {
    const { items = [], favorites = {}, fav_pop, onFavorite, onOpen, onViewAll } = this.props;
    const shown = items.slice(0, SHOW);

    return (
      <section className="hm-section" id="hm-featured">
        <div className="hm-container">
          <div className="hm-section__head">
            <h2 className="hm-section__title">{t("home_featured_title")}</h2>
            <button type="button" className="hm-section__link" onClick={onViewAll}>
              {t("view_all")}
              <span className="hm-ico">{ICON.chevron_right}</span>
            </button>
          </div>

          {shown.length ? (
            <div className="hm-grid">
              {shown.map((item) => (
                <HomePropertyCard
                  key={item.id}
                  item={item}
                  favorite={favorites[item.id]}
                  pop={fav_pop === item.id}
                  onFavorite={onFavorite}
                  onOpen={onOpen}
                />
              ))}
            </div>
          ) : (
            <div className="text-center py-5 hm-muted">{t("home_empty")}</div>
          )}
        </div>
      </section>
    );
  }
}
